module.exports = __webpack_public_path__ + "static/awards-13eb42d207a2c7d94827ffdb194518d4.jpg";